$ = jQuery;
$(document).ready(function () {

  // MAp JS Start
  function Zoom(args) {
    $.extend(this, {
      $buttons: $(".zoom-button"),
      $info: $("#zoom-info"),
      scale: { max: 50, currentShift: 0 },
      $container: args.$container,
      datamap: args.datamap
    });

    this.init();
  }

  Zoom.prototype.init = function () {
    var paths = this.datamap.svg.selectAll("path"),
      subunits = this.datamap.svg.selectAll(".datamaps-subunit");

    // preserve stroke thickness
    // paths.style("vector-effect", "non-scaling-stroke");

    // disable click on drag end
    subunits.call(
      d3.behavior.drag().on("dragend", function () {
        d3.event.sourceEvent.stopPropagation();
      })
    );

    this.scale.set = this._getScalesArray();
    this.d3Zoom = d3.behavior.zoom().scaleExtent([1, this.scale.max]);

    this._displayPercentage(1);
    this.listen();
  };

  Zoom.prototype.listen = function () {
    this.$buttons.off("click").on("click", this._handleClick.bind(this));

    this.datamap.svg
      .call(this.d3Zoom.on("zoom", this._handleScroll.bind(this)))
      .on("dblclick.zoom", null).on("wheel.zoom",
        null).on("mousewheel.zoom", null); // disable zoom on double-click and mouse scroll zoom
  };

  Zoom.prototype.reset = function () {
    this._shift("reset");
  };

  Zoom.prototype._handleScroll = function () {
    var translate = d3.event.translate,
      scale = d3.event.scale,
      limited = this._bound(translate, scale);

    this.scrolled = true;

    this._update(limited.translate, limited.scale);
  };

  Zoom.prototype._handleClick = function (event) {
    var direction = $(event.target).data("zoom");

    this._shift(direction);
  };

  Zoom.prototype._shift = function (direction) {
    var center = [this.$container.width() / 2, this.$container.height() / 2],
      translate = this.d3Zoom.translate(), translate0 = [], l = [],
      view = {
        x: translate[0],
        y: translate[1],
        k: this.d3Zoom.scale()
      }, bounded;

    translate0 = [
      (center[0] - view.x) / view.k,
      (center[1] - view.y) / view.k
    ];

    if (direction == "reset") {
      view.k = 1;
      this.scrolled = true;
    } else {
      view.k = this._getNextScale(direction);
    }

    l = [translate0[0] * view.k + view.x, translate0[1] * view.k + view.y];

    view.x += center[0] - l[0];
    view.y += center[1] - l[1];

    bounded = this._bound([view.x, view.y], view.k);

    this._animate(bounded.translate, bounded.scale);
  };

  Zoom.prototype._bound = function (translate, scale) {
    var width = this.$container.width(),
      height = this.$container.height();

    translate[0] = Math.min(
      (width / height) * (scale - 1),
      Math.max(width * (1 - scale), translate[0])
    );

    translate[1] = Math.min(0, Math.max(height * (1 - scale), translate[1]));

    return { translate: translate, scale: scale };
  };

  Zoom.prototype._update = function (translate, scale) {
    this.d3Zoom
      .translate(translate)
      .scale(scale);

    this.datamap.svg.selectAll("g")
      .attr("transform", "translate(" + translate + ")scale(" + scale + ")");

    this._displayPercentage(scale);
  };

  Zoom.prototype._animate = function (translate, scale) {
    var _this = this,
      d3Zoom = this.d3Zoom;

    d3.transition().duration(350).tween("zoom", function () {
      var iTranslate = d3.interpolate(d3Zoom.translate(), translate),
        iScale = d3.interpolate(d3Zoom.scale(), scale);

      return function (t) {
        _this._update(iTranslate(t), iScale(t));
      };
    });
  };

  Zoom.prototype._displayPercentage = function (scale) {
    var value;

    value = Math.round(Math.log(scale) / Math.log(this.scale.max) * 100);
    this.$info.text(value + "%");
  };

  Zoom.prototype._getScalesArray = function () {
    var array = [],
      scaleMaxLog = Math.log(this.scale.max);

    for (var i = 0; i <= 10; i++) {
      array.push(Math.pow(Math.E, 0.1 * i * scaleMaxLog));
    }

    return array;
  };

  Zoom.prototype._getNextScale = function (direction) {
    var scaleSet = this.scale.set,
      currentScale = this.d3Zoom.scale(),
      lastShift = scaleSet.length - 1,
      shift, temp = [];

    if (this.scrolled) {

      for (shift = 0; shift <= lastShift; shift++) {
        temp.push(Math.abs(scaleSet[shift] - currentScale));
      }

      shift = temp.indexOf(Math.min.apply(null, temp));

      if (currentScale >= scaleSet[shift] && shift < lastShift) {
        shift++;
      }

      if (direction == "out" && shift > 0) {
        shift--;
      }

      this.scrolled = false;

    } else {

      shift = this.scale.currentShift;

      if (direction == "out") {
        shift > 0 && shift--;
      } else {
        shift < lastShift && shift++;
      }
    }

    this.scale.currentShift = shift;

    return scaleSet[shift];
  };

  function Datamap() {
    this.$container = $("#map");
    //basic map config with custom fills, mercator projection
    this.instance = new Datamaps({
      scope: 'world',
      element: this.$container.get(0),
      //element: this.$container.get(0),
      done: this._handleMapReady.bind(this),
      scope: 'world',
      projection: 'mercator',
      geographyConfig: {
        popupOnHover: false,
        highlightOnHover: false
      },
      fills: {
        defaultFill: '#e0e0e0',
        bubbleColor: '#34AF9A',
      },

    });
    d3.selectAll(".datamaps-subunit").style("fill", "#e0e0e0");
    d3.selectAll(".datamaps-subunit").style("stroke", "#e0e0e0");

    this.instance.addPlugin('pins', function (layer, data, options) {
      var self = this,
        fillData = this.options.fills,
        svg = this.svg;

      if (!data || (data && !data.slice)) {
        throw "Datamaps Error - bubbles must be an array";
      }

      var bubbles = layer.selectAll('image.datamaps-pins').data(data, JSON.stringify);
      var pinSize = 20;
      bubbles.enter()
        .append('image')
        .attr('class', 'datamaps-pin')
        .attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/gfcp/images/greenpin.svg')
        .attr('height', pinSize)
        .attr('width', pinSize)
        .attr('x', function (datum) {
          //console.log('hey')
          var latLng;
          if (datumHasCoords(datum)) {
            latLng = self.latLngToXY(datum.latitude, datum.longitude);
          }
          if (latLng)
            return latLng[0] - pinSize / 2;
        })
        .attr('y', function (datum) {
          var latLng;
          if (datumHasCoords(datum)) {
            latLng = self.latLngToXY(datum.latitude, datum.longitude);
          }
          if (latLng)
            return latLng[1] - pinSize;
        })

        .on('click', function (datum) {
          //console.log(datum);
          //console.log('mousover!');
          $('.datamaps-pin').attr('href', document.getElementById('siteurl').value + '/themes/custom/gfcp/images/greenpin.svg');
          var $this = d3.select(this);
          $this.attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/gfcp/images/redpin.svg');
          var containerOffset = $(".map-container").offset();
          var left = d3.event.pageX - (containerOffset.left - 25);
          var top = (d3.event.pageY - containerOffset.top - 62);
          //var url = document.getElementById('siteurl').value;
          var pathname = window.location.host;
          console.log(pathname);
          var url = '';
          if (pathname == "115.113.146.196") {
            url = '/habitat';
          }

          $.ajax({
            url: url + "/getcitytooltip",
            type: 'GET',
            data: {
              city_code: datum.citycode,
              left_coordinates: left,
              top_coordinates: top
            },
            success: function (data) {
              var data = JSON.parse(data);
              $("#map-tooltip").empty();
              $("#map-tooltip").append(data.html);
              var tooltip = $(".map-tooltip").removeClass('d-none');
              var containerOffset = $(".map-container").offset();
              var left = data.left_cord;
              var top = data.top_cord - ($(".map-tooltip").height() / 2);
              $(".map-tooltip").show();
              $(".map-tooltip").css("left", left + "px");
              $(".map-tooltip").css("top", top + "px");
              hideTooltip();
            }
          });
        })
      // .on('mouseout', function (datum) {
      //   var $this = d3.select(this);
      //   $this.attr('xlink:href', document.getElementById('siteurl').value + '/themes/custom/gfcp/images/greenpin.svg');
      //   if (options.highlightOnHover) {
      //     //reapply previous attributes
      //     var previousAttributes = JSON.parse($this.attr('data-previousAttributes'));
      //     for (var attr in previousAttributes) {
      //       $this.style(attr, previousAttributes[attr]);
      //     }
      //   }
      //   $(".map-tooltip").addClass('d-none');
      //   $(this).removeClass('tooltip-hover');
      //   d3.selectAll('.datamaps-hoverover').style('display', 'none');
      // })


      bubbles.exit()
        .transition()
        .delay(options.exitDelay)
        .attr("height", 0)
        .remove();

      function datumHasCoords(datum) {
        return typeof datum !== 'undefined' && typeof datum.latitude !== 'undefined' && typeof datum.longitude !== 'undefined';
      }

    });

    //bubbles, custom popup on hover template
    this.instance.pins([{
      name: 'Ho Chi Minh',
      radius: 7,
      country: 'VNM',
      citycode: 'HCM',
      latitude: 10.8,
      longitude: 106.6,
    },
    {
      name: 'Istanbul',
      radius: 7,
      country: 'TUR',
      citycode: 'IST',
      latitude: 44,
      longitude: 35,
    },
    {
      name: 'Bursa',
      radius: 7,
      country: 'TUR',
      citycode: 'BUR',
      latitude: 42.5,
      longitude: 29.06,
    },
    {
      name: 'Ankara',
      radius: 7,
      country: 'TUR',
      citycode: 'ANK',
      latitude: 39.9,
      longitude: 32.85,
    },
    {
      name: 'Bangkok',
      radius: 7,
      country: 'THA',
      citycode: 'BNK',
      latitude: 13.75,
      longitude: 100.50,
    },
    {
      name: 'johneberg',
      radius: 7,
      country: 'ZAF',
      citycode: 'JHG',
      latitude: -26,
      longitude: 28,
    },
    {
      name: 'Durban',
      radius: 7,
      country: 'ZAF',
      citycode: 'DRN',
      latitude: -29.85,
      longitude: 31.02,
    },
    {
      name: 'Cape Town',
      radius: 7,
      country: 'ZAF',
      citycode: 'CTN',
      latitude: -33.92,
      longitude: 18.42,
    },
    {
      name: 'New Clark City',
      radius: 7,
      country: 'PHL',
      citycode: 'NCC',
      latitude: 15.18,
      longitude: 120.54,
    },
    {
      name: 'Cebu',
      radius: 7,
      country: 'PHL',
      citycode: 'CBU',
      latitude: 10.31,
      longitude: 123.89,
    },
    {
      name: 'Lagos',
      radius: 7,
      country: 'NGA',
      citycode: 'LGS',
      latitude: 9.46,
      longitude: 6.40,
    },
    {
      name: 'Abeokuta',
      radius: 7,
      country: 'NGA',
      citycode: 'ABK',
      latitude: 7.15,
      longitude: 3.34,
    },
    {
      name: 'Yangon',
      radius: 7,
      country: 'MMR',
      citycode: 'YGN',
      latitude: 16.87,
      longitude: 96.19,
    },
    {
      name: 'Iskandar',
      radius: 7,
      country: 'MYS',
      citycode: 'ISR',
      latitude: 1.49,
      longitude: 103.74,
    },
    {
      name: 'Melaka',
      radius: 7,
      country: 'MYS',
      citycode: 'MLK',
      latitude: 5.20,
      longitude: 102.24,
    },
    {
      name: 'Surabaya',
      radius: 7,
      country: 'IDN',
      citycode: 'SBY',
      latitude: -7.24,
      longitude: 112.75,
    },
    {
      name: 'Bandung',
      radius: 7,
      country: 'IDN',
      citycode: 'BDG',
      latitude: -6.90,
      longitude: 107.61,
    },
    {
      name: 'Recife',
      radius: 7,
      country: 'BRA',
      citycode: 'RFE',
      latitude: -8.05,
      longitude: -34.88,
    },
    {
      name: 'Belo Horizonte',
      radius: 7,
      country: 'BRA',
      citycode: 'BHZ',
      latitude: -19.91,
      longitude: -43.94,
    },
    ], {
      popupOnHover: true,
      popupTemplate: function (data) {
        return "<div class='hoverinfo'>It is " + data.name + "</div>";
      }
    });
  }
  function hideTooltip() {
    $('.closetooltip').click(function () {
      $(this).closest('.custom-map-tooltip').hide();
      $('.datamaps-pin').attr('href', document.getElementById('siteurl').value + '/themes/custom/gfcp/images/greenpin.svg');
    });
  }


  Datamap.prototype._handleMapReady = function (datamap) {
    this.zoom = new Zoom({
      $container: this.$container,
      datamap: datamap
    });
  }

  new Datamap();
});
